import {
  Href,
  Router,
  Slot,
  usePathname,
  useRouter
} from "expo-router";
import { useEffect } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useAppSelector } from "@/_hooks";
import styled from "styled-components/native";
import { TouchableOpacity } from "react-native";
import HomeLogo from "@/assets/icons/main/home.svg";
import ProfileLogo from "@/assets/icons/main/profile.svg";
import useCustomBottomSheet from "@/_hooks/useBottomSheet";
import {
  OPEN_CHECKING_COMPANY_SECTION,
  OPEN_CHECKING_PERSON_SECTION
} from "@/_utils/contstans";

const ACTIVE_OPACITY: number = .8;

const MainPage = () => {
  const router: Router = useRouter();
  const pathname = usePathname();
  const authToken: string | null = useAppSelector((state) => state.account.authToken);

  useEffect((): void => {
    (async (): Promise<void> => {
      try {
        const storedToken: string | null = await AsyncStorage.getItem("token");

        if (!authToken && !storedToken) {
          router.replace("/login");
        }
      } catch (err) {
        console.error(err, "not authorized");
        router.replace("/login");
      }
    })();
  }, [authToken, router]);

  const { openSheet } = useCustomBottomSheet();

  const isActive = (path: string) => pathname === path;

  const handleNavigate = (path: Href): void => router.push(path);
  const handleOpenSheet = (index: number): void => openSheet(index);

  return (
    <>
      <Slot />
      <Content>
        <NavBar
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{
            flexGrow: 1,
            flexShrink: 0,
            gap: 4,
            justifyContent: "center",
          }}
        >
          <NavButton
            activeOpacity={ACTIVE_OPACITY}
            isActive={isActive("/general")}
            onPress={() => handleNavigate("/(main)/general")}
          >
            <NavText>
              <HomeLogo />
            </NavText>
          </NavButton>
          <NavButtonGray
            activeOpacity={ACTIVE_OPACITY}
            onPress={() => handleOpenSheet(OPEN_CHECKING_COMPANY_SECTION)}
          >
            <NavText>Проверка <br/> компании</NavText>
          </NavButtonGray>
          <NavButtonGray
            activeOpacity={ACTIVE_OPACITY}
            onPress={() => handleOpenSheet(OPEN_CHECKING_PERSON_SECTION)}
          >
            <NavText>Проверка <br/> физ.лица</NavText>
          </NavButtonGray>
          <NavButton
            activeOpacity={ACTIVE_OPACITY}
            isActive={isActive("/profile")}
            onPress={() => handleNavigate("/(main)/profile")}
          >
            <NavText>
              <ProfileLogo />
            </NavText>
          </NavButton>
        </NavBar>
      </Content>
    </>
  );
};

export default MainPage;

const Content = styled.View`
  flex: 1;
  flex-grow: 0;
  background-color: transparent;
`;

const NavBar = styled.ScrollView`
  position: fixed;
  bottom: 12px;
  left: 16px;
  right: 16px;
  gap: 4px;
  padding: 12px;
  background-color: #101928;
  border-radius: 999px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.15;
  shadow-radius: 30px;
  max-width: 768px;
  margin: 0 auto;
  elevation: 6;
`;

const NavButton = styled(TouchableOpacity)<{ isActive?: boolean }>`
  padding: 12px;
  border-radius: 50%;
  width: 48px; 
  height: 48px;
  align-items: center;
  background-color: ${(props) => (props.isActive ? "#1677FF" : "rgba(255, 255, 255, 0.10)")};
`;

const NavButtonGray = styled(TouchableOpacity)`
  padding: 8px 24px;
  border-radius: 52px;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.10);
`;

const NavText = styled.Text`
  color: #fff;
  font-size: 13px;
  text-align: center;
  font-weight: 500;
`;
